// Block Definition: write_box
// Static layout block — a titled empty area for hand-writing on printouts.
// No data extraction. Layout: fills allocated height (container-sized).

export const writeBoxDef = {
  type: "write_box",
  label: "Write Box",
  description: "Titled empty write-in area for printouts.",
  crystallizer: null,
  renderer: null, // wired by ui/src/blockRegistryInit.js
  editor: {
    icon: "edit",
    category: "layout",
    defaultTemplate: { type: "write_box", label: "Write here" },
    configFields: [
      { name: "label", type: "string", label: "Section title" },
    ],
  },
};
